import { useEffect, useState } from "react";
import { getUser } from "../../../../services/authService";
import {
  updateAggregateContainerData,
  updateContainerData,
  updateFiveMContainerData,
} from "../../../../services/ContainerMasterService";
import { toast } from "react-toastify";
import moment from "moment";
import Tooltips from "../../../Custom Components/tooltip"

const DepartureEditableCell = ({
  value: initialValue,
  row: { original, index },
  column: { id },
  updateCellDataForFactoryIn,
  allowToEdit
}) => {
  const [dateValue, setDateValue] = useState(
    moment(initialValue).format("YYYY-MM-DD")
  );
  const [timeValue, setTimeValue] = useState(
    moment(initialValue).format("HH:mm")
  );
  // const [value, setValue] = useState(initialValue);
  const user = getUser();

  useEffect(() => {
    setDateValue(moment(initialValue).format("YYYY-MM-DD"));
    setTimeValue(moment(initialValue).format("HH:mm"));
  }, [initialValue]);


  async function onBlur() {
    if (id) {
      updateCellDataForFactoryIn(index, id, dateValue, timeValue);
    }
    if (original.ContainerMasterId) {
      if (
        original[id] !== new Date(dateValue + "T" + timeValue).toISOString()
      ) {
        if (original[id] !== "Invalid date") {
          if (original[id] !== `${dateValue}T${timeValue}`) {
            try {
              if (original.DataOf === "TRACTOR") {
                updateContainerData({
                  Id: `${original["ContainerMasterId"]}`,
                  columnName: `${id}`,
                  prevVal: original[id] ? original[id] : "",
                  value: `${dateValue}T${timeValue}`,
                  UserId: user.uid,
                });
              }
              if (original.DataOf === "AGGREGATE") {
                updateAggregateContainerData({
                  Id: `${original["ContainerMasterId"]}`,
                  columnName: `${id}`,
                  prevVal: original[id] ? original[id] : "",
                  value: `${dateValue}T${timeValue}`,
                  UserId: user.uid,
                });
              }
              if (original.DataOf === "5M") {
                updateFiveMContainerData({
                  Id: `${original["ContainerMasterId"]}`,
                  columnName: `${id}`,
                  prevVal: original[id] ? original[id] : "",
                  value: `${dateValue}T${timeValue}`,
                  UserId: user.uid,
                });
              }
              toast.success(
                `"Factory Out Date & Time" column updated with "${moment(
                  dateValue
                ).format("DD-MM-YYYY")},${timeValue}"`
              );
            } catch (error) {
              toast.error("Unable to update column");
            }
          }
        }
      }
    }
  }
  // if (id === "isOnHold") {
  //   if (value === 1 || value === true) {
  //     return "YES";
  //   } else return "NO";
  // }

  if (id === "Gate_Out_Date") {
    return (
      <>
        <input
          type="date"
          className="table_input"
          value={`${dateValue}`}
          onChange={(e) => setDateValue(e.currentTarget.value)}
          onBlur={onBlur}
          name={id}
          disabled={!allowToEdit}
        />
        <input
          type="time"
          className="table_input"
          value={`${timeValue}`}
          // step="3600"
          onChange={(e) => setTimeValue(e.currentTarget.value)}
          onBlur={onBlur}
          name={id}
          disabled={!allowToEdit}
        />
      </>
    );
  }
  if (id === "Dest_Port" || id === "final_destination" || id === "Remarks") {
    return (
      <Tooltips content={original[`${id}`]} direction="left">
        <input
          type="text"
          className="table_input"
          value={original[`${id}`]}
          name={id}
          disabled
        />
      </Tooltips>
    );
  }
  else {
    return (
      <input
        type="text"
        className="table_input"
        value={original[`${id}`]}
        // onChange={onChange}
        // onBlur={onBlur}
        name={id}
        disabled
      />
    );
  }
};

export const defaultDepartureReportColumn = {
  Cell: DepartureEditableCell,
};
